import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-chevron-right-icon lucide-chevron-right", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m9 18 6-6-6-6" }));
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
